import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import css from './CustomExtendedDataField.module.css';

const CustomFieldFileDisplay = ({ fileInfo, onDelete, fieldName }) => {
  if (!fileInfo || !fileInfo.fileUrl) {
    return null;
  }



  const handleDelete = async () => {
    if (!fileInfo.fileKey) return;

    try {
      const apiServerPort = process.env.REACT_APP_DEV_API_SERVER_PORT || '3500';
      const apiBaseUrl = process.env.NODE_ENV === 'development' 
        ? `http://localhost:${apiServerPort}` 
        : '';
      
      const response = await fetch(`${apiBaseUrl}/api/files/file/${encodeURIComponent(fileInfo.fileKey)}`, {
        method: 'DELETE',
        credentials: 'include', // Include cookies for authentication
      });

      if (response.ok) {
        onDelete(fieldName);
      } else {
        console.error('Failed to delete file');
      }
    } catch (error) {
      console.error('Error deleting file:', error);
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <div className={css.fileDisplay}>
      <div className={css.fileInfo}>
        <div className={css.fileDetails}>
          <span className={css.fileName}>{fileInfo.name}</span>
          <span className={css.fileSize}>{formatFileSize(fileInfo.size)}</span>
          <span className={css.fileType}>{fileInfo.type}</span>
        </div>
        <div className={css.fileActions}>
          <button
            type="button"
            className={css.deleteButton}
            onClick={handleDelete}
          >
            <FormattedMessage id="CustomFieldFileDisplay.delete" defaultMessage="Delete" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomFieldFileDisplay; 